"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var omit_1 = __importDefault(require("lodash/omit"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var SelectButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/SelectButton"));
var Input_1 = __importDefault(require("shared/components/Input/Input"));
var Text_1 = __importDefault(require("shared/components/Text"));
var analytics_1 = require("utils/analytics");
var hooks_1 = require("utils/hooks");
var other_1 = require("utils/selectors/other");
var single_1 = require("utils/selectors/single");
var PREFIX = 'TeamCreationInput';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    input: "".concat(PREFIX, "-input"),
    showChangeName: "".concat(PREFIX, "-showChangeName"),
};
var StyledBox = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.input)] = {
            borderRadius: 8,
            border: "1px solid ".concat(theme.palette.grey[400]),
            width: 245,
            padding: '0 1px',
            justifyContent: 'flex-start',
            fontSize: theme.typography.fontSize + 2,
            '& input': {
                boxShadow: 'none',
                padding: theme.spacing(0, 2),
            },
        },
        _b[".".concat(classes.showChangeName)] = {
            transition: '.2s ease-in-out',
            '.MuiButton-outlined': { width: 300 },
            '.MuiButton-text': { whiteSpace: 'nowrap' },
            '& > button:nth-of-type(2)': {
                opacity: 0,
            },
            '&:hover > button:nth-of-type(2)': {
                opacity: 1,
            },
        },
        _b);
});
var TeamCreationInput = function (_a) {
    var _b = _a.input, onChange = _b.onChange, value = _b.value, disabled = _a.disabled, isUserLeader = _a.isUserLeader;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var uniqueDepartments = (0, react_redux_1.useSelector)(other_1.selectUniqueDepartments);
    var _c = __read(react_1.default.useState(''), 2), newTeamName = _c[0], setNewTeamName = _c[1];
    var _d = __read(react_1.default.useState({}), 2), departmentInputs = _d[0], setDeptInputs = _d[1];
    var openDepartmentInput = function (dept) { return function () {
        var _a;
        return setDeptInputs(__assign(__assign({}, departmentInputs), (_a = {}, _a[dept] = '', _a)));
    }; };
    var closeDepartmentInput = function (dept) { return function () { return setDeptInputs((0, omit_1.default)(departmentInputs, [dept])); }; };
    var setDepartmentInput = function (dept) { return function (val) {
        var _a;
        return setDeptInputs(__assign(__assign({}, departmentInputs), (_a = {}, _a[dept] = val, _a)));
    }; };
    var departments = uniqueDepartments === null || uniqueDepartments === void 0 ? void 0 : uniqueDepartments.filter(function (dep) { return !(value === null || value === void 0 ? void 0 : value.find(function (_a) {
        var basedOn = _a.basedOn;
        return basedOn === dep;
    })); });
    var _e = __read((0, hooks_1.useSubmitter)('company_teams', undefined, { companyId: company === null || company === void 0 ? void 0 : company.id }), 2), teamCreator = _e[0], isSending = _e[1];
    var leaderId = isUserLeader && profile.id;
    var _f = __read((0, hooks_1.useSubmitter)('users', leaderId), 1), userSubmitter = _f[0];
    var track = (0, analytics_1.usePreparedTracker)('Add New Team');
    var addTeam = function (name, basedOn) { return function () { return __awaiter(void 0, void 0, void 0, function () {
        var newLastIdx, tmpId, newTeam, newTeamValue, newValue, teamRef;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    newLastIdx = value ? value.length : 0;
                    tmpId = "tmp_".concat(newLastIdx, "_").concat(name);
                    newTeam = { name: name, basedOn: basedOn, headcount: 1 };
                    if (isUserLeader) {
                        Object.assign(newTeam, { leaderId: leaderId, leadEmail: profile.email });
                    }
                    newTeamValue = __assign(__assign({}, newTeam), { id: tmpId });
                    newValue = !value ? [newTeamValue] : __spreadArray(__spreadArray([], __read(value), false), [newTeamValue], false);
                    onChange(newValue);
                    return [4 /*yield*/, teamCreator(newTeam)];
                case 1:
                    teamRef = _b.sent();
                    track({ action: 'Submit', value: name, source: 'Onboarding' });
                    if (!isUserLeader) return [3 /*break*/, 3];
                    return [4 /*yield*/, userSubmitter({ companyTeamId: teamRef.id, companyTeamRels: (_a = {}, _a[teamRef.id] = { role: 'LEAD' }, _a) })];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    newValue[newLastIdx].id = teamRef.id;
                    onChange(__spreadArray([], __read(newValue), false));
                    return [2 /*return*/];
            }
        });
    }); }; };
    var handlePrefill = function (selectedDept) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            track({ action: 'Selected Prefill', value: selectedDept, source: 'Onboarding' });
            addTeam(selectedDept, selectedDept)();
            return [2 /*return*/];
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(StyledBox, __assign({ mt: 4, className: classes.wrapper }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", alignItems: "center", spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(Input_1.default, { onChange: function (e) { return setNewTeamName(e.currentTarget.value); }, name: "newTeam", value: newTeamName, autoFocus: true, disabled: disabled, placeholder: "Type new team name", variant: "filled", classes: { root: classes.input } }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ disabled: !newTeamName || isSending || disabled, onClick: function () {
                            track({ action: 'Custom', value: newTeamName, source: 'Onboarding' });
                            addTeam(newTeamName)();
                            setNewTeamName('');
                        }, sx: { opacity: newTeamName ? 1 : 0, ml: 2 } }, { children: "Add" }))] })), departments && departments.length > 0 && !disabled && ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ my: 1 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ my: 1, width: 245 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, align: "center" }, { children: "or pick" })) })), departments === null || departments === void 0 ? void 0 : departments.map(function (dept) { return ((0, jsx_runtime_1.jsx)("div", { children: departmentInputs[dept] === undefined
                            ? ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", alignItems: "center", spacing: 2, my: 2, className: classes.showChangeName }, { children: [(0, jsx_runtime_1.jsx)(SelectButton_1.default, { size: "small", disabled: isSending, onClick: function () { return handlePrefill(dept); }, label: dept }), (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ onClick: openDepartmentInput(dept) }, { children: "change name" }))] }))) : ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ my: 1, direction: "row", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Input_1.default, { onChange: function (e) { return setDepartmentInput(dept)(e.currentTarget.value); }, value: departmentInputs[dept], name: "deptInput_".concat(dept), color: "secondary", placeholder: dept, autoFocus: true, variant: "filled", classes: { root: classes.input } }), (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ disabled: isSending, onClick: addTeam(departmentInputs[dept], dept) }, { children: "confirm" })), (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ onClick: closeDepartmentInput(dept), color: "neutral" }, { children: "close" }))] }))) }, dept)); })] })))] })));
};
exports.default = TeamCreationInput;
